/* VR 2026-10-02 — the cart drawer opens on every add to cart.
   The theme only opens it when its own product form submits. Globo Product
   Options and the sticky buy bar add straight through the Ajax API, so the item
   landed in the cart with nothing on screen. This watches the Ajax calls
   instead: anything that adds to the cart refreshes the drawer and opens it. */
(function () {
  if (!window.fetch) return;

  function drawer() { return document.querySelector('cart-drawer'); }

  function isCartPage() {
    return document.body.classList.contains('template-cart') || location.pathname.indexOf('/cart') === 0;
  }

  function refreshAndOpen() {
    var el = drawer();
    if (!el || isCartPage()) return;
    var ids = el.getSectionsToRender ? el.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    fetch('?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        el.renderContents({ sections: sections });
      })
      .catch(function () {
        if (el.open) el.open();
      });
  }

  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = url.indexOf('/cart/add') !== -1 && url.indexOf('vr=probe') === -1;
    return nativeFetch.apply(this, arguments).then(function (response) {
      if (isAdd && response.ok) setTimeout(refreshAndOpen, 350);
      return response;
    });
  };

  // Globo and some apps still use XMLHttpRequest.
  var open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__vrIsAdd = typeof url === 'string' && url.indexOf('/cart/add') !== -1 && url.indexOf('vr=probe') === -1;
    return open.apply(this, arguments);
  };
  var send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__vrIsAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) setTimeout(refreshAndOpen, 350);
      });
    }
    return send.apply(this, arguments);
  };
})();
